import { OrderType } from '../order/order';

export class DeliveryOption {
  label!: string;
  type!: ShippingType;
  isSelected!: boolean;
  descriptions?: (DeliveryOption & {
    productId: number;
  })[];
  additionalText?: string;
}
export class DeliveryLocation {
  id!: number;
  address!: string;
}

export enum ShippingType {
  Calculated = 'Calculated',
  FlatRatePerProduct = 'FlatRatePerProduct',
  SelfPickUp = 'SelfPickUp',
  FlatRatePerOrder = 'FlatRatePerOrder',
  OneWayDelivery = 'OneWayDelivery',
  OneWayPickup = 'OneWayPickup',
}

export function toShippingType(st: number | undefined): ShippingType {
  // case 0: // Calculated
  // case 1: // Flat shipping rate
  // case 2: // Self Pickup
  // case 3: // Flat shipping rate per order
  // case 4: // Will call option
  // case 5: // Google API One Way Delivery
  // case 6: // Google API One Way Pickup

  switch (st) {
    case 1:
      return ShippingType.FlatRatePerOrder;
    case 2:
      return ShippingType.SelfPickUp;
    case 3:
      return ShippingType.FlatRatePerOrder;
    case 5:
      return ShippingType.OneWayDelivery;
    case 6:
      return ShippingType.OneWayPickup;
    default:
      return ShippingType.Calculated;
  }
}

export const isDeliveryTripRequired = (st: ShippingType): boolean =>
  [
    ShippingType.Calculated,
    ShippingType.FlatRatePerOrder,
    ShippingType.FlatRatePerProduct,
    ShippingType.OneWayDelivery,
    ShippingType.OneWayPickup,
  ].includes(st);

export const formatShippingType = (st?: ShippingType, productType?: OrderType): string => {
  if (!st) {
    return '';
  }

  if (productType === OrderType.Sale && isDeliveryTripRequired(st)) {
    return 'Delivery';
  }
  switch (st) {
    case ShippingType.Calculated:
    case ShippingType.FlatRatePerProduct:
    case ShippingType.FlatRatePerOrder:
      return 'Delivery & Pickup';
    case ShippingType.SelfPickUp:
      return 'Self Pickup';
    case ShippingType.OneWayDelivery:
      return 'One Way At Rental Start';
    case ShippingType.OneWayPickup:
      return 'One Way Pickup At Rental End';
    default:
      return '';
  }
};

export enum DeliveryConfigType {
  PerProduct, //0
  Global, //1
  QuotedAfterOrder, //2
  ZipCode, //3
}

export function toDeliveryConfigType(type: number) {
  switch (type) {
    case 0:
      return DeliveryConfigType.PerProduct;
    case 1:
      return DeliveryConfigType.Global;
    case 2:
      return DeliveryConfigType.QuotedAfterOrder;
    case 3:
      return DeliveryConfigType.ZipCode;
    default:
      throw new Error(`Invalid DeliveryConfigType: ${type}`);
  }
}

// Delivery Config
export type DeliveryConfig = {
  type: DeliveryConfigType;
  taxable: boolean;
  allowOneWay: boolean;
  allowWillCallAtProductLevel: boolean;
  useMaxForPerProductDeliveryCalculation: boolean;
  flatRate: number;
  useGoogleCalculation: boolean;
  googleCalculation: GoogleCalculationMethod;
};
export type GoogleCalculationMethod = {
  measure: 'Mile' | 'Kilometer' | 'Minute';
  baseCost: number;
  includedUnits: number;
  perUnitCost: number;
};

// Product Delivery Config

export type ProductDeliveryConfig = {
  productId: number;
  allowShipping: boolean;
  allowPickup: boolean;
  forceWillCall: boolean;
  flatRate: number;
  useGoogleCalculation: boolean;
  googleCalculation: GoogleCalculationMethod;
};

export type UpdateProductDeliveryConfigRequest = {
  productId: number;
  allowShipping: boolean;
  allowPickup: boolean;
  forceWillCall?: boolean;
  rate?: number;
  baseCost?: number;
  includedUnits?: number;
  perUnitCost?: number;
};
